import { useState, useEffect } from "react";
import { motion } from "framer-motion";

function GithubStats() {
  const [stars, setStars] = useState(0);
  const [forks, setForks] = useState(0);

  useEffect(() => {
    const fetchStats = async () => {
      const response = await fetch(`https://api.github.com/users/sertacgltkn`);
      const data = await response.json();
      setStars(data.public_repos);
      setForks(data.public_gists);
    };
    fetchStats();
  }, []);

  return (
    <motion.div
      initial={{ y: 20, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ delay: 2, duration: 0.5 }}
      className="flex items-center space-x-4 mt-8"
    >
      <p className="text-white text-lg mb-2">
        GitHub Statistics: {stars} stars,{" "}
        {forks} forks <a href="https://github.com/sertacgltkn" className="text-white hover:text-gray-400"></a>
      </p>
    </motion.div>
  );
}

export default GithubStats;